import React from "react";
import axios from "axios";
import { AuthContextProvider } from "./context/AuthContext";
import { NotificationContextProvider } from "./context/NotificationContext";
import { ShowAllProvider } from "./context/ShowAllContext";
import { SearchProvider } from "./context/SearchContext";
import { ThemeProvider } from "./context/ThemeContext";
import CustomRouter from "./Router";
import './index.css';
import { ScenarioProvider } from "./context/ScenarioContext";
import AutoscrollButton from "./components/AutoscrollButton";

axios.defaults.withCredentials = true;

function App() {
  return (

      <ThemeProvider>
        <AuthContextProvider>
          <NotificationContextProvider>
            <ShowAllProvider>
              <SearchProvider>
                <ScenarioProvider>
                      <CustomRouter />
                </ScenarioProvider>
              </SearchProvider>
            </ShowAllProvider>
          </NotificationContextProvider>
        </AuthContextProvider>
      </ThemeProvider>
   
  );
}

export default App;
